class FreeShippingBar {
  constructor() {
    this.moneyFormat = window.Shopify?.money_format || '${{amount}}';
    this.init();
  }

  init() {
    this.updateAllBars();

    document.addEventListener('cart:refresh', () => {
      this.refresh();
    });

    document.addEventListener('DOMContentLoaded', () => {
      this.refresh();
    });

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (
        target.matches('input[name="updates[]"]') ||
        target.matches('.quantity__input')
      ) {
        this.refresh();
      }
    });

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (
        target.closest('button[name="plus"]') ||
        target.closest('button[name="minus"]') ||
        target.closest('button[type="submit"][name="add"]') ||
        target.closest('[name="add"]')
      ) {
        setTimeout(() => this.refresh(), 300);
        setTimeout(() => this.refresh(), 700);
      }
    });
  }

  async refresh() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      this.updateAllBars(cart);
    } catch (error) {
      console.error('Free shipping bar update failed:', error);
    }
  }

  updateAllBars(cart = null) {
    const bars = document.querySelectorAll('[data-free-shipping-bar]');
    if (!bars.length) return;

    if (cart) {
      bars.forEach((bar) => this.updateBar(bar, cart));
      return;
    }

    fetch('/cart.js')
      .then((response) => response.json())
      .then((fetchedCart) => {
        bars.forEach((bar) => this.updateBar(bar, fetchedCart));
      })
      .catch((error) => {
        console.error('Initial free shipping bar update failed:', error);
      });
  }

  updateBar(bar, cart) {
  const shippingThreshold = Number(bar.dataset.freeShippingThreshold || 6000);
  const giftThreshold = Number(bar.dataset.giftThreshold || 2500);
  const total = Number(cart.original_total_price || 0);

  const remainingToGift = Math.max(giftThreshold - total, 0);
  const remainingToShipping = Math.max(shippingThreshold - total, 0);

  const progress =
    shippingThreshold > 0
      ? Math.min((total / shippingThreshold) * 100, 100)
      : 0;

  const textEl = bar.querySelector('[data-free-shipping-text]');
  const subTextEl = bar.querySelector('[data-free-shipping-subtext]');
  const progressEl = bar.querySelector('[data-free-shipping-progress]');
  const giftMilestone = bar.querySelector('[data-gift-milestone]');
  const shippingMilestone = bar.querySelector('[data-shipping-milestone]');

  if (progressEl) {
    progressEl.style.setProperty('width', `${progress}%`, 'important');
  }

  const useShortLabels = true;

  this.updateMilestone(giftMilestone, total >= giftThreshold, {
    inactiveIcon: '🎁',
    activeIcon: '✓',
    inactiveLabel: useShortLabels ? '25 €' : '25 € · Ilmainen kristalli',
    activeLabel: useShortLabels ? '25 €' : '✓ Ilmainen kristalli'
  });

  this.updateMilestone(shippingMilestone, total >= shippingThreshold, {
    inactiveIcon: '🚚',
    activeIcon: '✓',
    inactiveLabel: useShortLabels ? '60 €' : '60 € · Ilmainen toimitus',
    activeLabel: useShortLabels ? '60 €' : '✓ Ilmainen toimitus'
  });

  if (!textEl) return;

  textEl.classList.remove(
    'free-shipping-bar__text--success',
    'free-shipping-bar-compact__text--success'
  );

  if (subTextEl) {
    subTextEl.innerHTML = '';
  }

  if (total < giftThreshold) {
    textEl.innerHTML = `🎁 Ilmainen kristalli yli 25€ tilauksiin`;

    if (subTextEl) {
      subTextEl.innerHTML = `Lisää vielä <strong>${this.formatMoney(
        remainingToGift
      )}</strong> 💜`;
    }
  } else if (total < shippingThreshold) {
    textEl.innerHTML = `🎁 Ilmainen kristalli lisätty koriin`;

    if (subTextEl) {
      subTextEl.innerHTML = `Lisää vielä <strong>${this.formatMoney(
        remainingToShipping
      )}</strong>, niin saat myös ilmaisen toimituksen 🚚`;
    }
  } else {
    if (textEl.classList.contains('free-shipping-bar-compact__text')) {
      textEl.classList.add('free-shipping-bar-compact__text--success');
    } else {
      textEl.classList.add('free-shipping-bar__text--success');
    }

    textEl.innerHTML = `🎁 Saat ilmaisen kristallin ja ilmaisen toimituksen`;

    if (subTextEl) {
      subTextEl.innerHTML = `Kaikki edut aktivoitu 💜`;
    }
  }
}

  updateMilestone(milestone, isActive, content) {
    if (!milestone) return;

    milestone.classList.toggle('is-active', isActive);

    const dot =
      milestone.querySelector('.free-shipping-bar__milestone-dot') ||
      milestone.querySelector('.free-shipping-bar-compact__milestone-dot');

    const label =
      milestone.querySelector('.free-shipping-bar__milestone-label') ||
      milestone.querySelector('.free-shipping-bar-compact__milestone-label');

    if (dot) {
      dot.textContent = isActive ? content.activeIcon : content.inactiveIcon;
    }

    if (label) {
      label.textContent = isActive ? content.activeLabel : content.inactiveLabel;
    }
  }

  formatMoney(cents) {
    return (cents / 100).toLocaleString('fi-FI', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }) + ' €';
  }
}

window.freeShippingBar = new FreeShippingBar();